export function actorDisplayName(actor) {
  if (!actor) return 'System';
  const local = String(actor).split('@')[0];
  const parts = local
    .replace(/[._-]/g, ' ')
    .split(' ')
    .map((part) => part.replace(/\d+$/g, ''))
    .filter(Boolean);
  const nameParts = parts.length > 2 ? [parts[0], parts[parts.length - 1]] : parts;
  if (!nameParts.length) return actor;
  return nameParts
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

export function actorInitials(actor) {
  const displayName = actorDisplayName(actor);
  if (displayName === 'System') return '';
  const parts = displayName.split(' ').filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
